import Tool from "@/utils/Tool";
import store from "@/store";
import { EventBus } from "@/utils/eventBus";

/**
 * WebSocket 封装 (Vue2 可用)
 * @author
 */
class Wsocket {
  constructor(url, events = {}) {
    this.serverUrl = url;

    // 心跳配置
    this.heartbeat = {
      open: true, // 是否开启心跳
      interval: 10 * 1000, // 心跳间隔
      timer: null,
    };

    // 重连配置
    this.reconnectConfig = {
      enable: true, // 是否开启重连
      timer: null,
      interval: 5 * 1000, // 重连间隔
      retry: 10, // 最大重连次数
    };

    // WebSocket 事件绑定
    this.events = {
      onOpen: () => {},
      onClose: () => {},
      onError: () => {},
    };
    Object.assign(this.events, events);

    // 自定义消息事件
    this.onEvent = {};

    // WebSocket 实例
    this.ws = null;
  }

  /**
   * 绑定自定义事件
   */
  on(eventName, callback) {
    this.onEvent[eventName] = callback;
  }

  /**
   * 连接 WebSocket
   */
  connect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }

    this.ws = new WebSocket(this.serverUrl);
    this.ws.onopen = this.onOpen.bind(this);
    this.ws.onclose = this.onClose.bind(this);
    this.ws.onerror = this.onError.bind(this);
    this.ws.onmessage = this.onMessage.bind(this);
  }

  /**
   * 处理连接成功
   */
  onOpen(evt) {
    console.log("WebSocket 连接成功");
    this.events.onOpen(evt);
    this.startHeartbeat();
  }

  /**
   * 处理连接关闭
   */
  onClose(evt) {
    console.log("WebSocket 连接关闭", evt);
    this.stopHeartbeat();

    if (evt.code === 1006) {
      this.tryReconnect();
    }

    this.events.onClose(evt);
  }

  /**
   * 处理错误
   */
  onError(evt) {
    console.error("WebSocket 出错", evt);
    this.events.onError(evt);
  }

  /**
   * 处理消息
   */
  onMessage(evt) {
    let result;
    try {
      result = JSON.parse(evt.data);
      console.log("socket返回值", result);
      if (result.type == "qr-login-success") {
        Tool.setToken(result.data.token);
        store.dispatch("user/setUserInfo", result.data.user);
        EventBus.$emit("loginSuccess");
      }
    } catch (e) {
      console.warn("WebSocket 收到非 JSON 数据:", evt.data);
      return;
    }
    if (result.type && this.onEvent[result.type]) {
      this.onEvent[result.type](result);
    } else {
      console.warn(`WebSocket 消息事件[${result.type}]未绑定...`);
    }
  }

  /**
   * 启动心跳
   */
  startHeartbeat() {
    if (this.heartbeat.open) {
      this.stopHeartbeat();
      this.heartbeat.timer = setInterval(() => {
        this.send("{'type':'ping'｝", true); // 心跳包
      }, this.heartbeat.interval);
    }
  }

  /**
   * 停止心跳
   */
  stopHeartbeat() {
    if (this.heartbeat.timer) {
      clearInterval(this.heartbeat.timer);
      this.heartbeat.timer = null;
    }
  }

  /**
   * 尝试重连
   */
  tryReconnect() {
    const cfg = this.reconnectConfig;
    if (!cfg.enable || cfg.retry <= 0) return;

    cfg.retry--;
    cfg.timer && clearTimeout(cfg.timer);

    cfg.timer = setTimeout(() => {
      console.log(`尝试重连... 剩余次数: ${cfg.retry}`);
      this.connect();
    }, cfg.interval);
  }

  /**
   * 发送数据
   * @param data 任意数据
   * @param raw 是否原样发送（true 表示直接字符串发送）
   */
  send(data, raw = false) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(raw ? data : JSON.stringify(data));
    } else {
      console.warn("WebSocket 未连接，无法发送");
    }
  }

  /**
   * 主动关闭
   */
  close() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
    this.stopHeartbeat();
  }
}

export default Wsocket;
